const KEY_ACCESS_TOKEN = '@app/holdDefurure/access_token';
const KEY_REFRESH_TOKEN = '@app/holdDefurure/refresh_token';
const KEY_ACCESS_EXPIRES_AT = '@app/holdDefurure/access_expires_at';

export interface TokenPair {
  access_token: string;
  refresh_token: string;
  expires_in: number;
}

function decodeJwtExpiryMs(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    const json = JSON.parse(
      atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    );
    return typeof json.exp === 'number' ? json.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function saveTokens(tokens: TokenPair) {
  localStorage.setItem(KEY_ACCESS_TOKEN, tokens.access_token);
  localStorage.setItem(KEY_REFRESH_TOKEN, tokens.refresh_token);
  localStorage.setItem(
    KEY_ACCESS_EXPIRES_AT,
    String(Date.now() + tokens.expires_in * 1000)
  );
}

export function clearTokens() {
  localStorage.removeItem(KEY_ACCESS_TOKEN);
  localStorage.removeItem(KEY_REFRESH_TOKEN);
  localStorage.removeItem(KEY_ACCESS_EXPIRES_AT);
}

export function getAccessToken(): string | null {
  return localStorage.getItem(KEY_ACCESS_TOKEN);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(KEY_REFRESH_TOKEN);
}

export function isAccessTokenValid(): boolean {
  const expiresAt = Number(localStorage.getItem(KEY_ACCESS_EXPIRES_AT));
  return Boolean(expiresAt) && Date.now() < expiresAt;
}

export function isRefreshTokenValid(): boolean {
  const token = getRefreshToken();
  if (!token) {
    return false;
  }
  const exp = decodeJwtExpiryMs(token);
  return Boolean(exp) && Date.now() < exp!;
}

export function hasAnyValidSession(): boolean {
  return isAccessTokenValid() || isRefreshTokenValid();
}
